import moment from "moment";
import "moment/locale/ru";
moment.locale("ru");
export var months = [
  {
    id: null,
    label: "Все",
    value: null,
  },
].concat(
  new Array(12).fill(null).map(function (_, id) {
    return {
      id: id,
      label: moment().add(id, "M").format("MMMM"),
      value: moment().add(id, "M"),
    };
  })
);
